'use strict';

var updateProgressBar = require('./updateProgressBar');
var updateFilterBadges = require('./updateFilterBadges');
var updateFilterStatus = require('./updateFilterStatus');
var toggleTasks = require('./toggleTasks');

function taskDone (taskElement, category, checked) {
  var $marketingChecklist = $('.marketing-checklist');
  var $bar = $marketingChecklist.find('.progress-bar');
  var stats = {};
  var counterModifier = checked ? 1 : -1;
  var cssClass = checked ? 'checked' : '';

  stats.autochecked = parseInt($bar.attr('data-autochecked'), 10);
  stats.checked = parseInt($bar.attr('data-checked'), 10) + counterModifier;
  stats.all = parseInt($bar.attr('data-all'), 10);
  stats.percent = ((stats.autochecked + stats.checked) / stats.all) * 100;

  updateProgressBar($('#dashboard-tasks-bars'), stats);
  updateProgressBar($marketingChecklist.find('.progress-container'), stats);
  updateFilterBadges($marketingChecklist, category, checked);
  updateFilterStatus($marketingChecklist);

  if (taskElement != null) {
    taskElement.attr('class', 'task-container ' + cssClass).removeAttr('style');
  }

  return toggleTasks($marketingChecklist);
}

module.exports = taskDone;
